/**
 * ToolLibraryDataApi
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Type of classification
 */
export const ToolDataModuleDataContractsClassificationType = {
  Undefined: 'Undefined',
  Custom: 'Custom',
  ClassGroup: 'ClassGroup',
  Din4000: 'Din4000',
  Iso13399: 'Iso13399',
  Interface: 'Interface',
} as const;

export type ToolDataModuleDataContractsClassificationType =
  (typeof ToolDataModuleDataContractsClassificationType)[keyof typeof ToolDataModuleDataContractsClassificationType];
